import React from "react";
import styles from "./DynamicCardRow.module.scss";
import DynamicCard from "../../common/AdminCommonComponents/DynamicCard/DynamicCard";
import { Col, Row } from "reactstrap";

const DynamicCardRow = ({ cards, xxl, lg, md, sm }) => {
    return (
        <Row className={styles.cardRow}>
            {cards.map((card, index) => (
                <Col key={index} sm={sm || "12"} md={md || "12"} lg={lg || "6"} xxl={xxl || "3"} className={styles.cardCol}>
                    <DynamicCard {...card} />
                </Col>
            ))}
        </Row>
    );
};

export default DynamicCardRow;